import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api'


export default /*#__PURE__*/_defineComponent({
  __name: 'IconsLetterIcon',
  props: {
    text: null,
    full: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  text?: string
  full?: boolean
};



const letter = computed(() => (props.text?.trim() ? props.text?.substring(0, 1) : 'H'))

const imgSize = computed(() => (props.full ? `w-full h-full` : 'size-12'))

return { __sfc: true,props, letter, imgSize }
}

})